
import axios from 'axios';
export const GENERATE_CASE_LIST_REPORT_PDF_REQUEST = 'GENERATE_CASE_LIST_REPORT_PDF_REQUEST';
export const GENERATE_CASE_LIST_REPORT_PDF_SUCCESS = 'GENERATE_CASE_LIST_REPORT_PDF_SUCCESS';
export const GENERATE_CASE_LIST_REPORT_PDF_FAILURE = 'GENERATE_CASE_LIST_REPORT_PDF_FAILURE';
const { REACT_APP_API_URL } = process.env;

export const generateCaseListReportPDFRequest = () => ({
  type: GENERATE_CASE_LIST_REPORT_PDF_REQUEST
});
export const generateCaseListReportPDFSuccess = payload => ({
  type: GENERATE_CASE_LIST_REPORT_PDF_SUCCESS,
  payload
});
export const generateCaseListReportPDFFailure = payload => ({
  type: GENERATE_CASE_LIST_REPORT_PDF_FAILURE,
  payload
});

export const caseListReportDataAction = payload => {
  return {
    type: 'CASELISTREPORTDATA',
    payload
  };
};

export const generateCaseListReportPdfAPI = (payload, successCallback, errorCallback, headers = {}) => {
  return dispatch => {
    dispatch(generateCaseListReportPDFRequest());
    axios
      .post(
        `${REACT_APP_API_URL}/client-case-list-report-pdf`,
        payload,
        {
          responseType: 'blob',
          headers: headers,
        }
      )
      .then(response => {
        if (response.headers['content-type'] === 'application/pdf') {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const downloadUrl = URL.createObjectURL(blob);
          window.open(downloadUrl, '_blank');

          dispatch(generateCaseListReportPDFSuccess());
        } else {
          errorCallback("Failed to generate PDF");
          dispatch(generateCaseListReportPDFFailure());
        }
      })
      .catch(error => {
        console.error("Error downloading PDF:", error);
        errorCallback("Error occurred while downloading PDF");
        dispatch(generateCaseListReportPDFFailure());
      });
  };
};

